export const rfidUsersResource = {
  name: 'RFID Users',
  fields: {
    id: 'ID',
    vendorId: 'Merchant',
    vendorName: 'Merchant Name',
    firstName: 'First Name',
    lastName: 'Last Name',
    displayName: 'Display Name',
    email: 'Email',
    phone: 'Phone',
    isActive: 'Active',
    createdAt: 'Created At',
    updatedAt: 'Updated At',
  },
  sections: {
    basicInfo: 'Basic Information',
    settings: 'Settings',
  },
  list: {
    subtitle: 'Manage RFID-only users without app access',
  },
  create: {
    title: 'Create RFID User',
    subtitle: 'Register a new RFID-only user',
    infoMessage: 'RFID users are for employees or contractors who need charging access without the mobile app.',
    vendorHelperText: 'Select the merchant/company this user belongs to',
    displayNameHelperText: 'This name will be shown on charging sessions and reports',
    emailHelperText: 'Optional - for notifications and receipts',
    phoneHelperText: 'Optional - for SMS notifications',
    cardInfo: 'RFID Card Assignment',
    cardHelperText: 'RFID cards can be assigned to this user after creation through the RFID Cards management page.',
  },
  edit: {
    title: 'Edit RFID User',
    subtitle: 'Update RFID user information',
    vendorHelperText: 'Select the merchant/company this user belongs to',
    displayNameHelperText: 'This name will be shown on charging sessions and reports',
    emailHelperText: 'Optional - for notifications and receipts',
    phoneHelperText: 'Optional - for SMS notifications',
  },
  show: {
    subtitle: 'View RFID user details',
  },
  notifications: {
    created: 'RFID user created',
    updated: 'RFID user updated',
  },
  groupsPanel: {
    title: 'Groups',
    empty: 'Not in any groups',
    selectPlaceholder: 'Select groups...',
    noOptions: 'No groups found',
    noGroupsExist: 'No user groups have been created yet.',
    manageGroups: 'Manage user groups',
    save: 'Save groups',
    saved: 'Groups saved',
  },
};

export const rfidUsers = {
  'rfid-users': rfidUsersResource,
};